import { Divider, Typography } from "@mui/material";

import CustomRating from "../../../Common/Rating/read-only-rating/CustomRating";
import STRINGS from "../constants/constants";
import { getInNetworkColor } from "../helper/functions";
import { STYLES } from "../styles/style";

export default function ViewHeader({ data = {} }) {
  const { name, inNetwork, receivingClients, rating } = data || {};
  const [badgeBgColor, badgeTextColor] = getInNetworkColor(inNetwork, receivingClients);
  return (
    <div className="flex w-full flex-col gap-4 p-4" style={STYLES.container}>
      <Typography sx={{ ...STYLES.headerName, wordBreak: "break-word" }}>{name}</Typography>

      {!inNetwork && !receivingClients && !rating ? (
        ""
      ) : (
        <div className="flex flex-wrap items-center gap-2">
          {inNetwork !== undefined && (
            <>
              <Typography sx={STYLES.headerLocation}>Location</Typography>
              <div
                className="px-4 py-1"
                style={{
                  ...STYLES.headerStatusBadge,
                  backgroundColor: badgeBgColor,
                }}
              >
                <Typography sx={{ color: badgeTextColor }}>
                  {STRINGS.NETWORK_STATUS_TYPE[inNetwork]}
                </Typography>
              </div>
            </>
          )}

          {rating && (
            <>
              <Divider orientation="vertical" flexItem />
              <CustomRating value={rating} />
            </>
          )}
        </div>
      )}
    </div>
  );
}
